import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Navigation, Router } from '@angular/router';
import { combineLatest, iif, Observable, of, throwError } from 'rxjs';
import { filter, flatMap, map, tap } from 'rxjs/operators';
import { LoggedInUserSettings } from 'src/app/core/services/settings/logged-in-user-settings';
import { SupportService } from 'src/app/core/services/support.service';

@Component({
  selector: 'pgh-chat-transcript',
  templateUrl: './chat-transcript.component.html',
  styleUrls: ['./chat-transcript.component.scss']
})
export class ChatTranscriptComponent implements OnInit {

  public transcript$: Observable<any>;

  public navigation: Navigation;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private supportService: SupportService,
    private loggedInUserSettings: LoggedInUserSettings
  ) {
    this.navigation = this.router.getCurrentNavigation();
  }

  ngOnInit(): void {
    if (!this.navigation?.extras?.state?.transcript && !this.activatedRoute?.snapshot?.params?.id) {
      this.transcript$ = throwError(new Error('No query parameter id present'));
      return;
    }

    this.transcript$ = iif(
      () => !!this.navigation?.extras?.state?.transcript,
      // Use passed transcript
      of(this.navigation.extras?.state?.transcript),
      // Get user phone number and retrieve transcripts to filter from backend
      // id query param must exist
      combineLatest([
        this.loggedInUserSettings.$selectedContract,
        this.loggedInUserSettings.$userClaims
      ]).pipe(
        filter(([contract, claims]) => !!contract && !!claims),
        map(([contract, claims]) => contract.members.find(m => m.emailAddress.toLowerCase() === claims.email.toLowerCase())),
        filter(member => !!member),
        flatMap((member: any) => this.supportService.getChatTranscripts(member.phoneNumber)
          .pipe(
            map((transcripts) => transcripts.find(t => t?.Id === this.activatedRoute?.snapshot?.params?.id)),
          )
        )
      )
    );
  }

}
